var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAragon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "#3164FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3758 7.05174L14.9762 5.56671C17.3961 5.2549 23.7815 5.65474 29.9629 9.74842C30.0432 10.3138 30.026 10.8774 30.026 10.8774L30.4815 11.124L30.484 11.1279L30.485 11.1221L30.4942 11.1278C30.7497 11.5665 31.0079 12.2206 31.1729 12.9903C31.3726 13.9216 31.4295 14.9938 31.1966 16.0192C30.9623 17.0523 30.5171 17.9048 30.0813 18.5285C29.7592 18.9894 29.4521 19.3114 29.2503 19.4877C28.4608 19.5045 26.9908 20.034 26.5706 21.8703C25.3044 22.595 23.3165 23.3194 20.6908 23.3194C18.1824 23.3194 15.6239 22.5929 13.7005 21.1861C11.7849 19.785 10.4984 17.7111 10.4984 14.9806C10.4984 12.8085 11.4718 11.1119 12.7063 9.86405C13.9449 8.61219 15.638 7.59789 16.62 7.26126L16.3758 7.05174ZM27.2227 10.6148C26.7361 11.1452 26.281 11.3997 26.1511 11.4687C23.3094 10.8362 22.2856 9.29781 22.2856 9.29781C24.9661 9.28052 27.3853 9.94763 29.1553 11.0762C29.1553 11.0762 28.1973 10.7513 27.2227 10.6148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9364 7.46253C8.84361 8.68961 4.19355 14.1761 4.19355 20.8106C4.19355 29.1984 11.2748 36.129 20.01 36.129C26.5327 36.129 31.9623 32.136 34.8011 26.7935C31.0255 27.6902 26.5176 26.0961 26.4889 22.6118C25.1298 23.3113 23.1727 23.9323 20.6908 23.9323C18.0748 23.9323 15.3842 23.1766 13.3394 21.681C11.2869 20.1798 9.88624 17.9311 9.88624 14.9806C9.88624 12.6078 10.9542 10.7641 12.2714 9.43273C13.0335 8.66973 14.0782 7.94563 14.9364 7.46253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7715 12.8617C31.6889 12.4766 31.5832 12.1123 31.4632 11.7813C33.1011 13.0068 34.3768 14.6792 34.2705 17.0095C34.1174 20.3658 32.0924 21.6865 30.7961 21.9065C31.4184 20.8611 30.8998 20.2008 30.6924 19.9806C30.5915 19.8737 30.3831 19.6932 30.0253 19.5808C30.2024 19.3866 30.3932 19.1511 30.5829 18.8798C31.055 18.2042 31.5384 17.2794 31.7935 16.155C32.0506 15.0229 31.985 13.858 31.7715 12.8617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAragon);
export default __webpack_public_path__ + "static/media/aragon.429ff460c197a23d7c7680bb17cdea4b.svg";
export { ForwardRef as ReactComponent };